import { render, staticRenderFns } from "./BiometricAuthenticationCard.vue?vue&type=template&id=0fed9be5"
import script from "./BiometricAuthenticationCard.vue?vue&type=script&lang=js"
export * from "./BiometricAuthenticationCard.vue?vue&type=script&lang=js"
import style0 from "./BiometricAuthenticationCard.vue?vue&type=style&index=0&id=0fed9be5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports